import { landingAssets } from 'assets/landing'
import { icons, images, logos, social } from 'common'
import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token-private.css */
  .yolo_token_page_wrapper {
    width: 100%;
    padding: 0;
    min-width: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
  }
  .yolo_token_page_wrapper h4 {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    margin: 3px 0 0 0;
  }
  .yolo_token_page_wrapper h4 a {
    text-decoration: none;
    color: #fff;
    font-size: 1rem;
    padding: 5px 10px;
    line-height: 140%;
    width: 100%;
    font-weight: 600;
    text-align: center;
    background: hsla(0, 0%, 100%, 0.1);
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.4);
    margin: 10px 0 0 0;
  }
  .yolo_token_page_wrapper h4 a:hover {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
    background: hsla(0, 0%, 100%, 0.2);
  }
  .yolo_token_page_wrapper .yt_page_left {
    border-right: 1px solid hsla(0, 0%, 100%, 0.2);
    width: 60%;
    padding: 40px 0 0 0;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .yolo_token_page_wrapper .yt_page_right {
    width: 40%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 40px 80px 0 80px;
  }
  .yolo_token_page_wrapper form.calculator {
    width: calc(100% - 160px);
    position: relative;
    margin: 30px 0 15px 0;
    padding: 25px 30px 30px 30px;
    border-radius: 10px;
    background: hsla(0, 0%, 100%, 0.05);
  }
  .yolo_token_page_wrapper form.calculator .fields_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
  }
  .yolo_token_page_wrapper form.calculator fieldset {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
  }
  .yolo_token_page_wrapper form.calculator .title {
    text-align: center;
    font-size: 1.3rem;
    font-weight: 600;
    margin-bottom: 15px;
    text-transform: uppercase;
    color: #deff00;
  }
  .yolo_token_page_wrapper form.calculator .current_yolo_price_wrap {
    text-align: center;
    padding: 20px 15px 10px 15px;
    font-size: 0.9rem;
    background: hsla(0, 0%, 0%, 0.2);
    border-radius: 15px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 0;
    width: 100%;
    margin: 5px 16px 0 16px;
    letter-spacing: -0.01em;
  }
  .yolo_token_page_wrapper form.calculator .current_yolo_price_wrap .current_yolo_price {
    color: #2159d1;
    font-weight: 800;
    font-size: 0.9rem;
    letter-spacing: -0.01em;
  }
  .yolo_token_page_wrapper form.calculator .amount_wrap.eth {
    margin: 0 !important;
  }
  .yolo_token_page_wrapper form.calculator .contribution_area {
    display: flex;
    flex-direction: column;
  }
  .yolo_token_page_wrapper .connect_to_mm {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.15);
    padding: 10px 0 25px 0;
    margin: 0 0 25px 0;
  }
  .yolo_token_page_wrapper .connect_to_mm button.mm {
    padding: 14px 28px 14px 52px;
    background: linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(245, 245, 245, 0.2),
      rgba(232, 232, 232, 0.2),
      rgba(222, 222, 222, 0.2),
      rgba(212, 212, 212, 0.2),
      rgba(201, 201, 201, 0.2),
      rgba(191, 191, 191, 0.2),
      rgba(181, 181, 181, 0.2)
    );
    position: relative;
    font-size: 1rem;
    border-radius: 20px;
  }
  .yolo_token_page_wrapper .connect_to_mm button.mm:hover {
    background: linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2)
    );
  }
  .yolo_token_page_wrapper .connect_to_mm button.mm:before {
    background: url(${icons.metamask_icon}) left center / 22px auto no-repeat;
    position: absolute;
    top: 50%;
    left: 22px;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    content: '';
  }
  .yolo_token_page_wrapper form.calculator .currency_equivalents {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .yolo_token_page_wrapper form.calculator div.swap {
    width: 50px;
    height: 50px;
    min-width: 50px;
    border-radius: 50%;
    z-index: 3;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: hsla(0, 0%, 100%, 0.1);
    -webkit-box-shadow: 0px 0 20px 1px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 0 20px 1px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0 20px 1px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(12, 35, 81, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
  .yolo_token_page_wrapper form.calculator div.swap .swap_icon {
    -webkit-mask: url(${icons.equal_thin_icon}) no-repeat;
    -webkit-mask-size: auto 18px;
    -webkit-mask-position: center center;
    mask: url(${icons.equal_thin_icon}) no-repeat;
    mask-size: auto 18px;
    mask-position: center center;
    background: #fff;
    width: 35px;
    height: 35px;
  }
  .yolo_token_page_wrapper form.calculator .amount_wrap:first-child {
    padding-left: 30px;
  }
  .yolo_token_page_wrapper form.calculator .amount_wrap:last-child {
    padding-right: 15px;
  }
  .yolo_token_page_wrapper form.calculator .amount_wrap.eth,
  .yolo_token_page_wrapper form.calculator .amount_wrap.yolo_token {
    background: hsla(0, 0%, 0%, 0.2);
    padding: 10px;
    border-radius: 10px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 15px;
    height: fit-content;
    width: 100%;
  }
  .yolo_token_page_wrapper form.calculator .amount_wrap.eth {
    border-radius: 0 0 0px 10px;
  }
  .yolo_token_page_wrapper form.calculator .button_container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 10px 0 0 0;
  }

  .yolo_token_page_wrapper form.calculator .details_message {
    font-size: 0.9rem;
    text-align: center;
    width: 100%;
    padding: 0 0 15px 0;
    line-height: 140%;
  }

  .yolo_token_page_wrapper form.calculator .button_container .details_message {
    font-size: 0.8rem;
    text-align: center;
    width: 100%;
    padding: 0 0 15px 0;
    line-height: 125%;
    opacity: 0.4;
  }
  .yolo_token_page_wrapper form.calculator:hover .button_container .details_message {
    opacity: 1;
  }
  .yolo_token_page_wrapper button.approve:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .yolo_token_page_wrapper button.approve {
    font-weight: 600;
    position: relative;
    color: #fff;
    padding: 15px 50px;
    border-radius: 20px;
    font-size: 1rem;
    margin: 0;
    width: 100%;
    height: 46px;
    transition: all 0.3;
  }
  .yolo_token_page_wrapper button.waiting {
    font-weight: 600;
    position: relative;
    color: #fff;
    padding: 15px 50px;
    border-radius: 20px;
    font-size: 1rem;
    margin: 0;
    width: 100%;
    height: 46px;
    background: transparent;
    border: 1px solid hsla(221, 73%, 47%, 0.8);
    cursor: not-allowed;
    transition: all 0.3;
  }
  .yolo_token_page_wrapper form.calculator .button_container .issue_message {
    color: red;
    font-size: 0.9rem;
    margin: 0 0 10px 0;
    display: none;
  }
  .yolo_token_page_wrapper form.calculator .amount_wrap .ind {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: 1.5rem;
    letter-spacing: -0.01em;
    font-weight: 300;
    min-width: 150px;
    margin: 0 0 0 5px;
  }
  .yolo_token_page_wrapper form.calculator .amount_wrap .ind .eth_icon {
    background: url('http://yolo.tino.me/app_v3/resources/images/assets/eth_icon.svg') center center / 40px 40px
      no-repeat;
    width: 40px;
    height: 40px;
    margin: 0 8px 0 0;
  }
  .yolo_token_page_wrapper form.calculator .amount_wrap .ind .yolo_token {
    background: url('http://yolo.tino.me/app_v3/resources/images/yolo_token/yolo_token.svg') center center / 40px 40px
      no-repeat;
    width: 40px;
    height: 40px;
    margin: 0 8px 0 0;
  }
  .yolo_token_page_wrapper form.calculator input {
    font-size: 1.2rem;
    padding: 20px 6px 18px 14px;
    text-align: left;
    border-radius: 10px;
    align-self: center;
    color: #fff;
    background: hsla(0, 0%, 100%, 0.1);
    margin: 0 0 0 5px;
  }
  .yolo_token_page_wrapper form.calculator input.fiat_amount {
    width: 50%;
    border-radius: 10px 0 0 10px;
  }
  .yolo_token_page_wrapper form.calculator input.amount {
    width: 50%;
    border-radius: 0 10px 10px 0;
  }
  .yolo_token_page_wrapper form.calculator input[readonly] {
    cursor: default;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda {
    padding: 40px 0 0 0;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda .question {
    font-size: 1.3rem;
    font-weight: 800;
    padding: 0 0 15px 0;
    letter-spacing: -0.01em;
    text-align: center;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda .answer {
    padding: 0 0 20px 0;
    text-align: center;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda .answer p {
    padding: 5px 0;
    font-size: 0.8rem;
    line-height: 160%;
    font-weight: 300;
  }
  .yolo_token_page_wrapper .yt_page_right .qanda .answer p b {
    font-weight: 800;
  }
  .yolo_token_page_wrapper .yt_page_right .callout_boxes {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 0 20px 0;
  }
  .yolo_token_page_wrapper .yt_page_right .callout_boxes .box {
    background: hsla(0, 0%, 100%, 0.1);
    border-radius: 10px;
    padding: 14px 24px 12px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 5px;
  }
  .yolo_token_page_wrapper .yt_page_right .callout_boxes .box .box_title {
    font-weight: 600;
    font-size: 0.8rem;
    padding: 0 0 5px 0;
  }
  .yolo_token_page_wrapper .yt_page_right .callout_boxes .box .box_value {
    font-size: 1.4rem;
    font-weight: 300;
    color: #deff00;
    letter-spacing: -0.01em;
  }
  .yolo_token_page_wrapper button.see_more {
    padding: 12px 24px;
    font-size: 1rem;
    border-radius: 20px;
  }
  .yolo_token_page_wrapper .yt_page_right .yt_logo_full {
    width: 200px;
    height: auto;
  }
  .yolo_token_page_wrapper h1 {
    font-size: 2.2rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    width: 100%;
    text-align: center;
    padding: 0 80px;
  }
  .yolo_token_page_wrapper h2 {
    font-size: 1.9rem;
    letter-spacing: -0.02em;
    font-weight: 300;
    padding: 10px 80px 0 80px;
    width: 100%;
    text-align: center;
  }
  .yolo_token_page_wrapper h3 {
    font-size: 0.9rem;
    padding: 10px 80px 0 80px;
    line-height: 140%;
    width: 100%;
    text-align: center;
  }
  @media (max-width: 1600px) {
    .yolo_token_page_wrapper h1 {
      font-size: 2rem;
      letter-spacing: -0.02em;
      padding: 0 60px;
    }
    .yolo_token_page_wrapper h2 {
      font-size: 1.7rem;
      letter-spacing: -0.01em;
      padding: 10px 60px 0 60px;
    }
    .yolo_token_page_wrapper h3 {
      padding: 10px 60px 0 60px;
    }
    .yolo_token_page_wrapper .yt_page_left form.calculator {
      width: calc(100% - 120px);
    }
    .yolo_token_page_wrapper .yt_page_right {
      padding: 40px 60px 0 60px;
    }
  }
  @media (max-width: 1200px) {
    .yolo_token_page_wrapper h1 {
      font-size: 1.8rem;
      padding: 0 40px;
    }
    .yolo_token_page_wrapper h2 {
      font-size: 1.5rem;
      padding: 10px 40px 0 40px;
    }
    .yolo_token_page_wrapper h3 {
      padding: 10px 40px 0 40px;
    }
    .yolo_token_page_wrapper .yt_page_left form.calculator {
      width: calc(100% - 80px);
    }
    .yolo_token_page_wrapper .yt_page_right {
      padding: 40px 40px 0 40px;
    }
    .yolo_token_page_wrapper .yt_page_right .yt_logo_full {
      width: 150px;
    }
  }
  @media (max-width: 1000px) {
    .yolo_token_page_wrapper {
      flex-direction: column;
    }
    .yolo_token_page_wrapper .yt_page_left,
    .yolo_token_page_wrapper .yt_page_right {
      width: 100%;
      border-right: 0;
      padding-top: 10px;
    }
    .yolo_token_page_wrapper h1 {
      padding: 0 30px;
    }
    .yolo_token_page_wrapper h2 {
      padding: 10px 30px 0 30px;
    }
    .yolo_token_page_wrapper h3 {
      padding: 10px 30px 0 30px;
      font-size: 0.8rem;
    }
    .yolo_token_page_wrapper .yt_page_left form.calculator {
      padding: 40px 30px;
    }
    .yolo_token_page_wrapper .yt_page_right {
      padding: 40px 30px 0 30px;
    }
  }
  @media (max-width: 600px) {
    .yolo_token_page_wrapper h1 {
      font-size: 1.5rem;
      letter-spacing: -0.01em;
    }
    .yolo_token_page_wrapper h2 {
      font-size: 1.3rem;
      letter-spacing: -0.01em;
    }
    .yolo_token_page_wrapper h3 {
      font-size: 0.7rem;
    }
    .yolo_token_page_wrapper .yt_page_left form.calculator {
      width: 100%;
      border-radius: 0;
      padding: 20px 30px;
    }
    .yolo_token_page_wrapper form.calculator .title {
      font-size: 1rem;
    }
    .yolo_token_page_wrapper form.calculator .amount_wrap.eth,
    .yolo_token_page_wrapper form.calculator .amount_wrap.yolo_token {
      margin: 3px 0;
      padding: 8px;
    }
    .yolo_token_page_wrapper form.calculator .amount_wrap .ind {
      min-width: 100px;
      font-size: 1.1rem;
    }
    .yolo_token_page_wrapper form.calculator .amount_wrap .ind .eth_icon,
    .yolo_token_page_wrapper form.calculator .amount_wrap .ind .yolo_token {
      background-size: 25px 25px;
      width: 25px;
      height: 25px;
    }
    .yolo_token_page_wrapper form.calculator input {
      margin: 0 0 0 5px;
      font-size: 0.9rem;
      width: 50% !important;
    }
    .yolo_token_page_wrapper form.calculator div.swap {
      width: 40px;
      height: 40px;
      min-width: 40px;
    }
    .yolo_token_page_wrapper form.calculator div.swap .swap_icon {
      -webkit-mask-size: auto 14px;
      mask-size: auto 14px;
      width: 14px;
      height: 14px;
    }
  }
  .yolo_token {
    background-image: url(${images.yolo_token});
    background-position: center center;
    background-size: 12px 12px;
    background-repeat: no-repeat;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const footerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 0.75rem;
    padding: 30px 60px;
    margin: 30px 0 0 0;
    align-items: center;
    position: relative;
    bottom: 0;
    z-index: 11;
    width: 100%;
    flex-wrap: nowrap;
  }
  footer #landing-details {
    display: flex;
    flex-direction: row;
    min-width: auto;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  footer .about {
    opacity: 0.3;
    width: 100%;
    max-width: 600px;
    text-align: center;
    line-height: 130%;
  }
  footer .about:hover {
    opacity: 1;
  }
  footer .about div {
    display: block;
    margin: 10px 0 0 0;
  }
  footer a {
    color: rgba(255, 255, 255, 1);
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  footer a:hover {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
  }
  footer #copyright,
  footer #priv-terms {
    white-space: nowrap;
  }
  footer #copyright {
    padding: 5px 15px;
    margin: 0 0 5px 0;
  }
  footer #priv-terms {
    margin: 0 0 5px 0;
  }
  footer #landing-social {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 15px 0 0 0;
  }
  footer #landing-social a.icon {
    background-color: #fff;
    mask-position: center center;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 0 15px;
    display: block;
  }
  footer #landing-social a.twitter {
    mask: url(${social.twitter_icon}) no-repeat;
    mask-size: auto 20px;
    width: 24px;
    height: 22px;
  }
  footer #landing-social a.tiktok {
    mask: url(${social.tiktok_icon}) no-repeat;
    mask-size: auto 20px;
    width: 24px;
    height: 22px;
  }
  footer #landing-social a.medium {
    mask: url(${social.medium_icon}) no-repeat;
    mask-size: auto 18px;
    width: 22px;
    height: 18px;
  }
  footer #landing-social a.telegram {
    mask: url(${social.telegram_icon}) no-repeat;
    mask-size: auto 20px;
    width: 23px;
    height: 20px;
  }
  footer #landing-social a.discord {
    mask: url(${social.discord_icon}) no-repeat;
    mask-size: auto 20px;
    width: 26px;
    height: 20px;
  }
  footer #landing-social a.email {
    mask: url(${social.email_icon}) no-repeat;
    mask-size: auto 22px;
    width: 32px;
    height: 22px;
  }
  footer #landing-social a.icon:hover {
    background-color: #2e68eb;
  }
`

const mmConnected = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token-private.css */
  .yolo_token_page_wrapper .connect_to_mm {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.15);
    padding: 10px 0 25px 0;
    margin: 0 0 25px 0;
  }
  .yolo_token_page_wrapper .connect_to_mm .connected_status {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-size: 0.9rem;
    font-weight: 600;
  }
  .yolo_token_page_wrapper .connect_to_mm .connected_status img {
    width: 18px;
    height: 18px;
    margin: 0 10px 0 0;
  }
  .yolo_token_page_wrapper .connect_to_mm .switch_to_mn {
    display: flex;
    width: fit-content;
    justify-content: center;
    align-items: center;
    padding: 5px 15px;
    background: hsla(340, 88%, 46%, 0.15);
    font-size: 0.8rem;
    margin: 15px 0 0 0;
    width: calc(100% + 60px);
  }
  .yolo_token_page_wrapper .connect_to_mm .switch_to_mn button.switch_to_mainnet {
    background: linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(245, 245, 245, 0.2),
      rgba(232, 232, 232, 0.2),
      rgba(222, 222, 222, 0.2),
      rgba(212, 212, 212, 0.2),
      rgba(201, 201, 201, 0.2),
      rgba(191, 191, 191, 0.2),
      rgba(181, 181, 181, 0.2)
    );
    position: relative;
    font-size: 0.75rem;
    border-radius: 10px;
    padding: 6px 14px;
    margin: 0 0 0 10px;
    white-space: nowrap;
  }
  .yolo_token_page_wrapper .connect_to_mm .connected_status button.mm_disconnect {
    background: linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(245, 245, 245, 0.2),
      rgba(232, 232, 232, 0.2),
      rgba(222, 222, 222, 0.2),
      rgba(212, 212, 212, 0.2),
      rgba(201, 201, 201, 0.2),
      rgba(191, 191, 191, 0.2),
      rgba(181, 181, 181, 0.2)
    );
    position: relative;
    font-size: 0.7rem;
    border-radius: 10px;
    padding: 4px 12px;
    margin: 0 0 0 10px;
  }
  .yolo_token_page_wrapper .connect_to_mm .switch_to_mn button.switch_to_mainnet:hover,
  .yolo_token_page_wrapper .connect_to_mm .connected_status button.mm_disconnect:hover {
    background: linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2)
    );
  }
  .yolo_token_page_wrapper .wallet_id_full {
    padding: 15px 30px;
    white-space: nowrap;
    font-size: 0.9rem;
    background: hsla(0, 0%, 0%, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-all;
    border-radius: 10px;
    margin: 15px 0 0 0;
  }
  .yolo_token_page_wrapper .mm_balance {
    font-size: 1rem;
    padding: 15px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .yolo_token_page_wrapper .mm_balance strong {
    font-weight: 600;
  }
  @media (max-width: 600px) {
    .yolo_token_page_wrapper .mm_details {
      width: 100%;
    }
    .yolo_token_page_wrapper .wallet_id_full {
      margin: 0 -30px;
      border-radius: 0;
    }
    .yolo_token_page_wrapper .connect_to_mm .switch_to_mn {
      flex-direction: column;
      padding: 10px 0;
    }
    .yolo_token_page_wrapper .connect_to_mm .switch_to_mn button.switch_to_mainnet {
      margin: 5px 0 0 0;
    }
  }
`

const yoloBalanceCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token-private.css */
  .yolo_token_page_wrapper .yolo_balance {
    width: calc(100% + 60px);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: hsla(221, 73%, 47%, 0.3);
    margin: -25px -30px 25px -30px;
    border-radius: 10px 10px 0 0;
    padding: 10px 30px;
    font-size: 1rem;
  }
  .yolo_token_page_wrapper .yolo_balance strong {
    font-weight: 600;
    padding: 0 0 0 5px;
  }
`

const contributeAgainCSS = css`
  .yolo_token_page_wrapper .button_container .success_message button.contribute_again {
    background: linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(245, 245, 245, 0.2),
      rgba(232, 232, 232, 0.2),
      rgba(222, 222, 222, 0.2),
      rgba(212, 212, 212, 0.2),
      rgba(201, 201, 201, 0.2),
      rgba(191, 191, 191, 0.2),
      rgba(181, 181, 181, 0.2)
    );
    padding: 8px 15px;
    font-size: 0.8rem;
    margin: 10px 0 0 0;
  }
  .yolo_token_page_wrapper .button_container .success_message button.contribute_again:hover {
    background: linear-gradient(
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2)
    );
  }
`

const successMessageCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/yolo_token-private.css */
  .yolo_token_page_wrapper .copy_icon {
    width: 14px;
    height: 14px;
    margin: 0 0 0 10px;
  }
  .success_message {
    width: 100%;
    background: hsla(126, 100%, 38%, 0.1);
    padding: 15px 30px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 10px;
  }
  .success_message .row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .success_message .row .label {
    text-transform: uppercase;
    font-size: 0.7rem;
    padding: 0 0 5px 0;
  }
  .success_message .row .trans_hash {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .success_message .row a {
    text-decoration: none;
    color: #fff;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  .success_message .row a:hover {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
  }
  .success_message strong {
    display: flex;
    flex-wrap: nowrap;
    color: hsl(126, 100%, 38%);
    font-weight: 600;
    font-size: 1rem;
    padding: 0 0 8px 0;
  }
`

const developerCSS = css`
  .scroll_wrapper {
    display: flex;
    flex-direction: column;
    margin-top: 70px;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100% - 70px);
    justify-content: space-between;
  }
  form .field_error {
    color: #de0e54;
    margin: 5px 0 0 0;
    font-size: 0.8rem;
  }
  .indentation {
    padding-left: 15px !important;
  }
  .investor_list {
    padding: 0 0 40px 0;
  }
  .investor_list li.item {
    padding: 5px 0 0 15px;
  }
`

export const PrivatePresaleCSS = styled.div`
  position: relative;
  overflow: hidden;
  padding-top: 70px;
  height: 100%;
  background: url(${images.yolo_token_bg_2}) center center / cover no-repeat;
  ${designerCSS}
  ${mmConnected}
  ${yoloBalanceCSS}
  ${successMessageCSS}
  ${contributeAgainCSS}
  ${footerCSS}
  ${developerCSS}
`
export const CopyIcon = styled(IconLib).attrs({ dimension: '16px' })`
  right: 15px;
  margin: 0 0 0 10px;
  &:hover {
    cursor: pointer;
  }
`
